module.exports = __webpack_public_path__ + "img/painting.c655e4e1.png";